import React from 'react';
import { Link } from 'react-router-dom';
import '../../pages/Auth.css';

const AuthLayout = ({ children }) => {
  const supportEmail = (process.env.REACT_APP_SUPPORT_EMAIL || '').trim();
  return (
    <main className="enterprise-auth-page">
      <div className="enterprise-auth-shell">
        <header className="enterprise-auth-header">
          <Link to="/welcome" className="enterprise-auth-logo" aria-label="Qflow home">
            <span aria-hidden="true">Q</span>
            <strong>Qflow</strong>
          </Link>
        </header>
        <section className="enterprise-auth-workspace" aria-label="Qflow account access">
          {children}
        </section>
        <footer className="enterprise-auth-footer">
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
          {supportEmail ? <a href={`mailto:${supportEmail}`}>Support</a> : <Link to="/contact">Support</Link>}
        </footer>
      </div>
    </main>
  );
};

export default AuthLayout;
